import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#561651',
    },
    secondary: {
      main: '#D09F53',
    },
    error: {
      main: '#c40505',
    },
    custom: {
      darkBlue: '#001A41',
      lightBlue: '#3e79d3',
      lightGray: '#efefef',
      red: '#CC0000',
      white: '#fafafa',
      black: '#000000',
      gold: '#ffd400',
      success: '#0a9b00',
      whisper: '#E5E5E5',
      smoke: '#F0F0F0',
      selago: '#fff0ff',
      linkWater: '#d3d4d5',
      nobel: '#a0a0a0',
      suvaGrey: '#909090',
      darkGrey: '#b0b0b0',
      gainsboro: '#DDDDDD',
      reef: '#c5e1a5',
      geraldine: '#e57373',
      limeGreen: '#21BA16',
      corn: '#fff956',
      toryBlue: '#244096',
      rust: '#BA3F16',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['Cantarell'].join(','),
  },
  components: {
    MuiIcon: {
      styleOverrides: {
        colorSecondary: {
          color: '#D09F53 !important',
        },
        colorPrimary: {
          color: '#561651 !important',
        },
      },
    },
  },
});

export { theme };
